import {
  ContextualMenu,
  FontWeights,
  IButtonStyles,
  IContextualMenuItem,
  IDropdown,
  IDropdownOption,
  ITextField,
  mergeStyles,
  mergeStyleSets,
  TextField,
} from "@fluentui/react";
import { Component, createRef } from "react";
import { connect } from "react-redux";

import { RootState } from "../../../../../App/store";
import brands from "../../../../../shared/brands.json";
import { emptyFn } from "../../../../../utils/common";
import { productsSearch, SearchProduct } from "../../../../../utils/search";
import { theme } from "../../../../../utils/theme";
import NumberField, { commaNumber } from "../../../../NumberField";
import { actions } from "../../../slice";
import { getFormState } from "../../../slice/newFormReducers";
import { addNewProductRow } from "./";

type Props = {
  uuid: string;
  reduxProduct?: RegisteredProductInfo | CustomProductInfo;
  shipmentEditMode?: boolean;
};

type State = {
  suggestionsVisible: boolean;
  newProductModalOpen: boolean;
  addingCustomProduct: boolean;
  itemSubmitDisabled: boolean;
  inputError?: string;
  items: IContextualMenuItem[];
  product?: RegisteredProductInfo | CustomProductInfo;
};

export type RegisteredProductInfo = {
  lastUpdateTime?: number;
  custom: false;
  id: string;
  // versionId: string;
  name: string;
  price: number;
};

export type CustomProductInfo = {
  lastUpdateTime?: number;
  custom: true;
  name: string;
  price: number;
};

const initialState = () => ({
  suggestionsVisible: false,
  newProductModalOpen: false,
  addingCustomProduct: false,
  itemSubmitDisabled: false,
  items: [],
});

class ProductInput extends Component<Props, State> {
  private _container = createRef<HTMLDivElement>();
  private _contextualMenu = createRef<HTMLDivElement>();
  private _textField = createRef<ITextField>();
  private _textFieldHolder = createRef<HTMLDivElement>();
  private _suggestionsTarget = createRef<HTMLDivElement>();
  private __brandDropdown = createRef<IDropdown>();
  private __itemNameField = createRef<ITextField>();
  private __priceField = createRef<ITextField>();
  private autoFocusInp = false;
  private searchHash = 0;
  private initedProduct: any = undefined;
  private initedUUID = "";

  constructor(props: Props) {
    super(props);

    this.state = initialState();

    this.initProduct(true);
  }

  initProduct(fromConstruct?: boolean) {
    const stateProds = getFormState().products;
    const productInfo = stateProds?.[this.props.uuid]?.productInfo;

    this.initedUUID = this.props.uuid;

    if (this.state.product !== productInfo) {
      if (fromConstruct)
        this.state = { ...initialState(), product: productInfo };
      else this.setState({ product: productInfo });
    }
  }

  componentDidUpdate() {
    if (this.props.uuid !== this.initedUUID) {
      this.initProduct();
    }

    if (this.props.reduxProduct !== this.initedProduct) {
      this.initedProduct = this.props.reduxProduct;
      this.setState({ product: this.props.reduxProduct });
    }
  }

  componentDidMount() {
    this.autoFocusInp = false;
  }

  render() {
    return (
      <div
        ref={this._container}
        className={containerStyles}
        onBlurCapture={this._onBlurAny.bind(this)}
      >
        {this.renderTextField()}
        {this.state.suggestionsVisible && this.renderSuggestions()}
      </div>
    );
  }

  search(query?: string) {
    const hash = Date.now() + Math.random();
    this.searchHash = hash;

    if (this.state.items.length !== 0) {
      this.setState({ items: [] });
    }

    if (!query) {
      return;
    }

    setTimeout(async () => {
      if (hash !== this.searchHash) return;

      const result = await productsSearch.search<SearchProduct>(
        query,
        searchOpts
      );
      if (hash !== this.searchHash) return;

      const items: IContextualMenuItem[] = result.hits
        .filter((hit) => typeof hit.price === "number")
        .map((hit) => {
          const brand = brands.find((b) => b.id === hit.brand?.toLowerCase());

          return {
            key: `product:${hit.objectID}`,
            text: (
              <>
                {/* {prettyString(brand?.name)}{" "} */}
                {[hit.size, hit.description].filter((v) => v).join(" ")}{" "}
                <small>{hit.note}</small>
              </>
            ) as any as string,
            secondaryText: `Satış Fiyatı: ${commaNumber(hit.price || 0)} TL`,
            iconProps: {
              imageProps: {
                src: brand?.searchIcon,
                width: 16,
              },
            },
            data: hit,
            onClick: this._onSearchProductItemClick.bind(this),
          };
        });

      this.setState({ items });
    }, 400);
  }

  setProduct(
    product: RegisteredProductInfo | CustomProductInfo | undefined,
    priceNotImportant?: boolean
  ) {
    if (product !== undefined) {
      product.lastUpdateTime = Date.now();

      if (!priceNotImportant) {
        actions.setFormProductVariable([
          this.props.uuid,
          "sellPrice",
          product.price,
        ]);
      }

      // add new line if no empty remaining
      const stateProducts = getFormState().products;

      if (stateProducts) {
        let hasEmptyRow = false;

        for (const key in stateProducts)
          if (
            key !== this.props.uuid &&
            Object.prototype.hasOwnProperty.call(stateProducts, key)
          ) {
            const product = stateProducts[key];

            if (!product.productInfo) hasEmptyRow = true;
          }

        if (!hasEmptyRow) addNewProductRow();
      }
    }

    // this.autoFocusInp = true; // auto focus after product changes (ex. when prod removed)

    actions.setFormProductVariable([this.props.uuid, "productInfo", product]);
    this.setState({ product, items: [] });
  }

  setProductByQuery(query: string) {
    const product: RegisteredProductInfo | CustomProductInfo = this.state
      .product
      ? { ...this.state.product }
      : { custom: true, name: "", price: 0 };

    product.name = query;

    this.setProduct({ ...product }, true);
  }

  private renderTextField() {
    return (
      <div ref={this._textFieldHolder}>
        <TextField
          disabled={this.props.shipmentEditMode}
          autoFocus={this.autoFocusInp}
          componentRef={this._textField}
          onFocus={this._onFocusAny.bind(this)}
          onChange={(_, nv) => {
            // this._updateInputError(false);
            this.setProductByQuery(nv || "");
          }}
          onKeyUp={() => {
            this.search(this.state.product?.name);
          }}
          value={this.state.product?.name || ""}
          // errorMessage={this.state.inputError}
        />
        <div
          ref={this._suggestionsTarget}
          style={{
            position: "absolute",
            width: "75%",
            minWidth: "500px",
          }}
        />
      </div>
    );
  }

  private renderSuggestions() {
    if (!this._container.current) return <></>;

    return (
      <ContextualMenu
        items={this.state.items}
        ref={this._contextualMenu}
        useTargetWidth
        onRestoreFocus={emptyFn}
        shouldFocusOnContainer={false}
        shouldFocusOnMount={false}
        target={this._suggestionsTarget.current}
      />
    );
  }

  private _updateInputError(errorOverride?: boolean) {
    const value = this._textField.current?.value;
    const isErroring = !!this.state.inputError;
    const shouldError = !!(typeof errorOverride === "boolean"
      ? errorOverride
      : value);

    if (isErroring !== shouldError) {
      this.setState({
        inputError: shouldError ? "Hatalı ürün girişi" : undefined,
      });
    }
  }

  private _onSearchProductItemClick(_: any, item?: IContextualMenuItem) {
    if (!item) return;

    const product = item.data as SearchProduct;

    this.setProduct({
      custom: false,
      id: product.uuid || "",
      // versionId: item.data.versionId,
      name: [product.size, product.description].filter((v) => v).join(" "),
      price: product.price || 0,
    });
  }

  private _onFocusAny() {
    this.setState({ suggestionsVisible: true });
  }

  private _onBlurAny(e: React.FocusEvent<HTMLDivElement, Element>) {
    if (this._contextualMenu.current?.contains(e.relatedTarget)) {
      e.preventDefault();
      this._textField.current?.focus();
    } else {
      this._updateInputError();
      this.setState({ suggestionsVisible: false });
    }
  }
}

const stackTokens = { childrenGap: 10 };
const searchOpts = { hitsPerPage: 7 };
const brandsDropdownOptions: IDropdownOption[] = [
  ...brands.map((brand) => ({ key: brand.id, text: brand.name })),
  // { key: "divider0", text: "", itemType: DropdownMenuItemType.Divider },
  // { key: "other", text: "Diğer Marka / Özel Ürün" },
];
const productInfoStackStyles = mergeStyles({
  borderBottom: `1px dotted ${theme.palette.neutralLight}`,
});
const containerStyles = mergeStyles({
  display: "block",
  width: "100%",
  height: "100%",
});
const modalContentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    minWidth: "20vw",
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
  },
});
const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

export default connect(
  (state: RootState, props: Props) => ({
    reduxProduct:
      state.currentForm.newForms[state.currentForm.editingNewFormUUID]
        ?.products?.[props.uuid]?.productInfo,
  }),
  {}
)(ProductInput);
